export default "__VITE_ASSET__ClrbXTye__"